module.exports = __webpack_public_path__ + "static/media/Tshirts-ISNP-banner.06794940.jpg";